import * as api from "~/api/resource";

export default {
    async mounted() {


        this.userList = await api.getModxList('gears/userinfo', {userList: true})

        this.pups = await this.getPups();
        switch (this.userDomain) {
            case 'travel':
                this.excrs_services = await this.getTripServices();
                this.services = await api.getModxList("route/getoptions", {
                    limit: 0,
                    valueField: 'details'

                });
                break;
            default:
                // _log_('heloooooooooooo')
                this.services = await this.getTripServices();


        }

        this.loading = false;
    },
    computed: {

        priceRules() {
            const vehicleTypes = {
                default: [
                    {value: "private", label: "Private"},
                    {value: "mini", label: "Mini Bus"},
                    {value: "medium", label: "Medium Bus"},
                    {value: "normal", label: "Normal Bus"},
                    {value: "big", label: "Big Bus"},
                    {value: "double", label: "Double Bus"},
                ]
            }
            const vm = this, locsIndex = vm.$store.state.LocsIndex
            return {
                travel: {
                    excursion: [
                        {
                            prop: "transtype",
                            minWidth: "250px",
                            label: "Distributor(Lang)",
                            editable: true,
                            editorcomponent: {
                                is: "s-remote-select",
                                dark: vm.themeCtx == 'dark',
                                allowCreate: true,
                                extraQueryParams: {
                                    labelField: 'distributor',
                                    limit: 0,
                                    companyId: this.formDada?.tourCoId,
                                    action: 'booking/getoptions',
                                    valueField: 'distributor',
                                },
                                fetchProcessor:"booking/getoptions",
                                queryProp:"query",
                                valueProp: "distributor",
                                labelProp: "distributor"
                                // multiple: true
                            },
                            viewcomponent: {
                                is: "s-remote-select",
                                dark: vm.themeCtx == 'dark',
                                allowCreate: true,
                                extraQueryParams: {
                                    labelField: 'distributor',
                                    limit: 0,
                                    companyId: this.formDada?.tourCoId,
                                    action: 'booking/getoptions',
                                    valueField: 'distributor',
                                },
                                fetchProcessor:"booking/getoptions",
                                queryProp:"query",
                                valueProp: "distributor",
                                labelProp: "distributor",
                                viewMode: true
                                // multiple: true
                            }
                        },

                        {
                            prop: "product",
                            width: "",
                            label: "Excursion",
                            editable: true,
                            editorcomponent: {
                                is: "s-general-select",
                                options: vm.excrs_services,
                                labelProp: "title",
                                stringfy: true,

                                valueProp: "id"

                                // multiple: true
                            },
                            viewcomponent: {
                                is: "s-general-select",
                                options: vm.excrs_services,
                                labelProp: "title",
                                stringfy: true,

                                valueProp: "id",
                                viewMode: true
                                // multiple: true
                            }
                        },
                        {
                            label: "Pax>=",
                            prop: "paxA",
                            width: 100,
                            minWidth: 30,
                            maxWidth: 180,
                            editable: true,
                            onChange(ev, row) {

                                if (row.paxZ < row.paxA) {
                                    // row.paxZ=null
                                    vm.$message.error("You have confused pax limits the higher pax value must be higher than the minimum");
                                }

                            },
                        },
                        {
                            label: "<=Pax",
                            prop: "paxZ",
                            width: 100,
                            minWidth: 30,
                            maxWidth: 180,
                            onChange(ev, row) {
                                // _log_('row.paxZ <row.paxA', row.paxZ, row.paxA, row)
                                if (row.paxZ < row.paxA) {
                                    // row.paxA=null
                                    vm.$message.error("You have confused pax limits the higher pax value must be higher than the minimum");
                                }

                            },
                            editable: true,

                        },
                        {

                            prop: "adultPrice",
                            editable: true,
                            formatter(val) {
                                return vm.formatNumber(val);
                            },
                            editorcomponent: {
                                is: "s-number"
                            },
                            label: "Adult Price"
                        },
                        {

                            prop: "kidPrice",
                            editable: true,
                            formatter(val) {
                                return vm.formatNumber(val);
                            },
                            editorcomponent: {
                                is: "s-number"
                            },
                            label: "Kid Price"
                        },
                        {

                            prop: "routePrice",
                            editable: true,
                            formatter(val) {
                                return vm.formatNumber(val);
                            },
                            editorcomponent: {
                                is: "s-number"
                            },
                            label: "Fixed Price"
                        },
                        {
                            prop: "delete",
                            width: "60px",
                            label: "X",
                            fixed: "right",
                            sortable: false,
                            viewcomponent: {
                                is: "el-button",
                                icon: "el-icon-delete",
                                type: "danger",
                                circle: true
                            },
                            formatter(val, colDefs, row) {
                                return "-";
                                // return '<button type="button" class="el-button el-button--default is-circle"><i class="el-icon-close"></i></button>';
                            }
                        }
                        // { prop: "year", width: "", label: "Date", formatterType: "unxToDate" }
                    ],
                    default: [

                        {

                            prop: "routeseq",
                            minWidth: "250px",
                            label: "Route",

                            editable: true,

                            editorcomponent: {
                                // is: "s-remote-select",
                                is: "RouteBuilder",
                                // multiple: true,
                                // queryProp: "q",
                                // classModel: "locations",
                                // labelProp: "name",
                                // valueProp: "id",

                            },
                            onChange(ev, row) {
                                // _log_("is..onChange..", ev, row);
                                if (ev.obj && ev.obj.name) {
                                    row.loc_name = ev.obj.name

                                }

                            },
                            formatter: function (val, cols, row) {
                                _log_('l pups..', val, locsIndex)
                                if (val && vm.$store.state.Pups_all?.length) {
                                    let o = []
                                    if (val.split != undefined)
                                        val = val.split(',')
                                    val
                                        .forEach(loc => o.push(locsIndex[loc].code))
                                    return o.join(',')
                                }
                                // return val && row.loc_name ? row.loc_name : ''
                            },
                        },
                        {
                            prop: "vehicletype",
                            width: "",
                            label: "Vehicle type",
                            editable: true,
                            editorcomponent: {
                                is: "s-general-select",
                                options: vehicleTypes.default,
                                valueProp: 'value'
                                // simpleOptions: true

                                // multiple: true
                            },
                            formatter: function (val, cols, row) {
                                return vm.findInArray(vehicleTypes.default, {value: val})?.label
                            }
                        },
                        {
                            prop: "product",
                            width: "",
                            label: "Trip Service",
                            editable: true,
                            editorcomponent: {
                                is: "s-general-select",
                                options: vm.services,
                                labelProp: "details",
                                stringfy: true,

                                valueProp: "details"

                                // multiple: true
                            },
                            viewcomponent: {
                                is: "s-general-select",
                                options: vm.services,
                                labelProp: "details",
                                stringfy: true,

                                valueProp: "details",
                                viewMode: true
                                // multiple: true
                            }
                        },
                        {
                            label: "Pax>=",
                            prop: "paxA",
                            width: 100,
                            minWidth: 30,
                            maxWidth: 180,
                            editable: true,
                            onChange(ev, row) {

                                if (row.paxZ < row.paxA) {
                                    // row.paxZ=null
                                    vm.$message.error("You have confused pax limits the higher pax value must be higher than the minimum");
                                }

                            },
                        },
                        {
                            label: "<=Pax",
                            prop: "paxZ",
                            width: 100,
                            minWidth: 30,
                            maxWidth: 180,
                            onChange(ev, row) {
                                _log_('row.paxZ <row.paxA', row.paxZ, row.paxA, row)
                                if (row.paxZ < row.paxA) {
                                    // row.paxA=null
                                    vm.$message.error("You have confused pax limits the higher pax value must be higher than the minimum");
                                }

                            },
                            editable: true,

                        },
                        {

                            prop: "adultPrice",
                            editable: true,
                            formatter(val) {
                                return vm.formatNumber(val);
                            },
                            editorcomponent: {
                                is: "s-number"
                            },
                            label: "Adult Price"
                        },
                        {

                            prop: "kidPrice",
                            editable: true,
                            formatter(val) {
                                return vm.formatNumber(val);
                            },
                            editorcomponent: {
                                is: "s-number"
                            },
                            label: "Kid Price"
                        },
                        {

                            prop: "routePrice",
                            editable: true,
                            formatter(val) {
                                return vm.formatNumber(val);
                            },
                            editorcomponent: {
                                is: "s-number"
                            },
                            label: "Fixed Price"
                        },
                        {
                            prop: "delete",
                            width: "60px",
                            label: "X",
                            fixed: "right",
                            sortable: false,
                            viewcomponent: {
                                is: "el-button",
                                icon: "el-icon-delete",
                                type: "danger",
                                circle: true
                            },
                            formatter(val, colDefs, row) {
                                return "-";
                                // return '<button type="button" class="el-button el-button--default is-circle"><i class="el-icon-close"></i></button>';
                            }
                        }
                        // { prop: "year", width: "", label: "Date", formatterType: "unxToDate" }
                    ]
                }
            }
        }
    }
}
